window.addEventListener("DOMContentLoaded", function () {
    var cardSliders = document.querySelectorAll(".card-slider");
    cardSliders.forEach(function (e) {
        var slider = new Splide('#' + e.id, {
            perPage: 3,
            gap: '1rem',
            padding: { right: '15%' },
            arrows: false,
            breakpoints: {
                992: {
                    perPage: 2,
                },
                760: {
                    perPage: 1,
                },
            }
        }).mount();

        if (e.querySelector('.splide__arrows')) {
            e.querySelector('.prev-arrow').addEventListener('click', function () {
                slider.go('<');
            });

            e.querySelector('.next-arrow').addEventListener('click', function () {
                slider.go('>');
            });
        }
    });
})